// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"4cf60836","236":"c6993800","256":"aa183720","407":"6108657c","453":"13a4105c","484":"da51e1ef","523":"1f1f8b09","553":"335367c8","617":"8080fba4","834":"e193506b","893":"3cf75d4d","944":"fc9357af"}[chunkId] + ".chunk.js";
};